import request from '@/utils/request1'

// ==================== 模板主表相关接口 ====================

// 查询模板列表
export function listTemplates(data) {
    return request({ url: '/dailyTemplate/QDailyTemplateApi', method: 'post', data })
}

// 新增模板
export function addTemplate(data) {
    return request({ url: '/dailyTemplate/ADailyTemplateApi', method: 'post', data })
}

// 修改模板
export function updateTemplate(data) {
    return request({ url: '/dailyTemplate/UDailyTemplateApi', method: 'post', data })
}

// 删除模板
export function deleteTemplate(data) {
    return request({ url: '/dailyTemplate/DDailyTemplateApi', method: 'post', data })
}

// ==================== 模板主项目相关接口 ====================
// 查询模板主项目列表
export function listItems(data) {
    return request({ url: '/dailyItem/QDailyItemApi', method: 'post', data })
}

// 新增模板主项目
export function addItem(data) {
    return request({ url: '/dailyItem/ADailyItemApi', method: 'post', data })
}

// 修改模板主项目
export function updateItem(data) {
    return request({ url: '/dailyItem/UDailyItemApi', method: 'post', data })
}

// 删除模板主项目
export function deleteItem(data) {
    return request({ url: '/dailyItem/DDailyItemApi', method: 'post', data })
}

// 获取默认模板
export function defaultTemplate(data) {
    return request({ url: '/dailyChild/DefaultTemplateApi', method: 'post', data })
}

// 初始化模板（一键创建包含mock数据的模板）
export function initializeTemplate(data) {
    return request({ url: '/dailyTemplate/InitializeTemplateApi', method: 'post', data })
}

// ==================== 模板子项目相关接口 ====================

// 查询模板子项目列表
export function listChildItems(data) {
    return request({ url: '/dailyChild/QDailyChildApi', method: 'post', data })
}

// 新增模板子项目
export function addChildItem(data) {
    return request({ url: '/dailyChild/ADailyChildApi', method: 'post', data })
}

// 修改模板子项目
export function updateChildItem(data) {
    return request({ url: '/dailyChild/UDailyChildApi', method: 'post', data })
}

// 删除模板子项目
export function deleteChildItem(data) {
    return request({ url: '/dailyChild/DDailyChildApi', method: 'post', data })
}

// ==================== 模板关联关系相关接口 ====================

// 获取主项目关联的模板列表
export function getItemTemplateRelations(data) {
    return request({ url: '/dailyItem/QDailyItemApi', method: 'post', data })
}